import React, { useEffect, useState } from 'react';
import { getdata, updatedata, deletedata } from "../../util/global";
import MasterTable from './MasterTable';
import MasterOpsTeamForm from './MasterOpsTeamForm';
import { opsteamuser, opsteamuserdef } from './Datatype';

const Master = () => {
  const [teamdata, setteamdata] = useState<opsteamuser[]>([]);
  const [showmodal, setshowmodal] = useState("");
  const [formdata, setformdata] = useState<opsteamuser>(opsteamuserdef);

  const fetchdata = async () => {
    try {
      const res = await getdata({ filter: { datatype: "appuser", usertype: "admin" } });
      setteamdata(res ? [...res].reverse() : []);
    } catch (err) {
      console.error("fetch ops user error:", err);
    }
  };

  const handlesubmit = async () => {
    const payload = {
      data: {
        ...formdata,
        datatype: "appuser",
        usertype: "admin"
      }
    };
    await updatedata(payload);
    setshowmodal("");
    fetchdata();
  };

  const changeuserstatus = async (item: opsteamuser, status:string) => {
    if (!confirm(`set status to ${status} for user ${item.email} ?`)) return;
    item.status = status;
    const payload = {
      data:item
    };

    await updatedata(payload);
    setshowmodal("");
    fetchdata();
  };

  const openadd = () => {
    setformdata({ ...opsteamuserdef });
    setshowmodal("showopsteamform");
  };

  const openedit = (item: opsteamuser) => {
    setformdata({ ...item, password: '' });
    setshowmodal("showopsteamform");
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0 }}>Internal Operations Team Configuration</h3>
        <button className="btn-blue" onClick={openadd}>
          + Add Ops User
        </button>
      </div>

      <MasterTable 
        teamdata={teamdata} 
        openedit={openedit} 
        changeuserstatus={changeuserstatus} 
      />

      <MasterOpsTeamForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        formdata={formdata} 
        setformdata={setformdata} 
        handlesubmit={handlesubmit} 
      />
    </div>
  );
};

export default Master;